import {useEffect} from 'react';
import Logger from '@nl/logger';
import {event, EVENT_TYPES} from '../utils/event';

const satelliteTrack = (key, info) => {
	// eslint-disable-next-line no-underscore-dangle
	if (window._satellite) {
		try {
			// eslint-disable-next-line no-underscore-dangle
			window._satellite.track(key, info);
		} catch (e) {
			Logger.error('useAdobeLaunchTracker: _satellite.track error!', e);
		}
	} else {
		Logger.error('useAdobeLaunchTracker: window._satellite doesn\'t exist');
	}
};

function useAdobeLaunchTracker() {
	useEffect(() => {
		const addRemoveFavPlayerCallback = (isAdd, id) => {
			if (isAdd === false) {
				return;
			}
			try {
				const [, f, l] = id.split(':');
				satelliteTrack('add favorite player', {
					playerName: `${f} ${l}`,
				});
			} catch (e) {
				Logger.error('useAdobeLaunchTracker: addRemoveFavPlayerCallback error');
			}
		};
		const addRemoveFavTeamCallback = (isAdd, {code}, allFavTeams = []) => {
			if (isAdd === false) {
				return;
			}
			satelliteTrack('add favorite team', {
				teamName: code,
			});
		};
		const subscriptionStartCallback = () => {
			satelliteTrack('purchase initiate');
		};
		const subscriptionSuccessCallback = () => {
			satelliteTrack('payment info success');
		};
		const videoSearchCallback = (info = {}) => {
			satelliteTrack('video search', info);
		};
		const videoSearchResultSort = (info = {sortID: 'nba:watch:search-results:sort', sortOrder: ''}) => {
			satelliteTrack('search results sort', info);
		};
		const videoListFiltersUpdate = (filtersTrack) => {
			satelliteTrack('update filter', filtersTrack);
		};
		const selectPackage = (sku) => {
			satelliteTrack('lppp-sku-select', sku);
		};
		const promoCodeCheck = ({errors, promoname, recurring, requireBilling, requireCreditCard,
															zerocost, freetrial_newprice}) => {
			if (errors && errors.length === 0) {
				satelliteTrack('payflow: promo code valid');
			} else {
				satelliteTrack('payflow: promo code invalid');
			}
		};
		event.on(EVENT_TYPES.ADD_FAVORITE_TEAM, addRemoveFavPlayerCallback)
				.on(EVENT_TYPES.ADD_FAVORITE_TEAM, addRemoveFavTeamCallback)
				.on(EVENT_TYPES.TRACK_SUBSCRIPTION_SUCCESSFUL, subscriptionSuccessCallback)
				.on(EVENT_TYPES.TRACK_SUBSCRIPTION_START, subscriptionStartCallback)
				.on(EVENT_TYPES.TRACK_VIDEO_SEARCH_EVENT, videoSearchCallback)
				.on(EVENT_TYPES.TRACK_VIDEO_SEARCH_RESULTS_SORT, videoSearchResultSort)
				.on(EVENT_TYPES.TRACK_VIDEO_LIST_FILTER_UPDATE, videoListFiltersUpdate)
				.on(EVENT_TYPES.TRACK_PACKAGE_SELECT, selectPackage)
				.on(EVENT_TYPES.TRACK_PROMO_CODE_CHECK, promoCodeCheck);
		return () => {
			event.off(EVENT_TYPES.ADD_FAVORITE_TEAM, addRemoveFavPlayerCallback)
					.off(EVENT_TYPES.ADD_FAVORITE_TEAM, addRemoveFavTeamCallback)
					.off(EVENT_TYPES.TRACK_SUBSCRIPTION_SUCCESSFUL, subscriptionSuccessCallback)
					.off(EVENT_TYPES.TRACK_SUBSCRIPTION_START, subscriptionStartCallback)
					.off(EVENT_TYPES.TRACK_VIDEO_SEARCH_EVENT, videoSearchCallback)
					.off(EVENT_TYPES.TRACK_VIDEO_SEARCH_RESULTS_SORT, videoSearchResultSort)
					.off(EVENT_TYPES.TRACK_VIDEO_LIST_FILTER_UPDATE, videoListFiltersUpdate)
					.off(EVENT_TYPES.TRACK_PACKAGE_SELECT, selectPackage)
					.off(EVENT_TYPES.TRACK_PROMO_CODE_CHECK, promoCodeCheck);
		};
	}, []);
}

export default useAdobeLaunchTracker;
